<template>
	<div class="ReLeadLentaNest" >

				
		<card class="postForm mt-2 mb-4" :class="{'focus-shadow' : !bIsPostForm}">
			<div class="postForClick" @click="showPostForm()">
				<h5 class="mr-3"><i class="tim-icons icon-send text-success mr-3"></i>Написать</h5>
				
			</div>
			<div v-if="!bIsPostForm" class="cancel-note-btn">
				<base-button  @click="cancelForm()" type="danger" class="no-border" simple icon><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
			</div>
			<div class="postAddForm" :class="[bIsPostForm ? 'postAddForm-hide' : 'postAddForm-show']">		
				<!-- <form class="form-container">
					<div class="top_part">           
						<textarea 
						class="form-control"
						placeholder="Текст"
						ref="saveInput"						
						v-model="strNote">	
						</textarea>	
					</div>
					<div class="bottom_part mt-2 pb-1">
						<template v-if="fileUpload_model==''">
							<div class="upload-file"> 
								<ReFileUpload 
									v-model="fileUpload_model"
									type="file"
									:multiple="false"
									
									acceptMime="*/*"
									:bShowTrash="false"
									v-on:change="OnUploadFile"
								/>
							</div>
						</template>
						<template v-else>
							<h5 class="upload-file">
								<a :href="fileUpload_model.fullpath" target="_blank">Посмотреть документ</a>
								<button class="ml-2 btn btn-icon btn-simple btn-danger" @click="DoDel()">
									<i class="tim-icons icon-trash-simple"></i>
								</button>
							</h5>
						</template>
						
						<base-button v-if="strNote!='' || fileUpload_model!=''" type="success" simple icon @click="SendNote()" class="mr-0"><i class="d-inline-block tim-icons icon-send"></i></base-button>											
					</div>
				</form>	 -->

				<!--оставить версию с табами для следующего релиза-->
				<tabs type="primary" 
					:activeTab="value"
					tabNavWrapperClasses="tab-opt"
					inline										
					square			
					class="">
					<tab-pane :id="'tb_1'" >
						<span slot="label" class="tab-label">
							<i class="tab-icon tim-icons icon-caps-small"></i><span>Заметка</span>
						</span>
						<form class="form-container">
							<div class="top_part">           
								<textarea 
								class="form-control"
								placeholder="Текст"
								ref="saveInput"
								v-model="strNote">	
								</textarea>	
							</div>
							<div class="bottom_part mt-2 pb-1">
								<template v-if="fileUpload_model==''">
									<div class="upload-file"> 
										<ReFileUpload 
											v-model="fileUpload_model"
											type="file"
											:multiple="false"
											
											acceptMime="image/*,application/pdf,application/mspowerpoint,application/powerpoint,application/vnd.ms-powerpoint,application/x-mspowerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
											:bShowTrash="false"
											v-on:change="OnUploadFile"
										/>
									</div>
								</template>
								<template v-else>
									<h5 class="upload-file">
										<a :href="fileUpload_model.fullpath" target="_blank">Посмотреть документ</a>
										<button class="ml-2 btn btn-icon btn-simple btn-danger" @click="DoDel()">
											<i class="tim-icons icon-trash-simple"></i>
										</button>
									</h5>
								</template>
								
								<base-button v-if="strNote!='' || fileUpload_model!=''" type="success" simple icon @click="SendNote()" class="mr-0"><i class="d-inline-block tim-icons icon-send"></i></base-button>
							</div>
						</form>
					</tab-pane>

					<!-- <tab-pane :id="'tb_2'">
						<span slot="label" class="tab-label">
							<i class="tab-icon tim-icons icon-mobile"></i><span>СМС</span>
						</span>
						
						<form class="form-container">
							<div class="top_part">           
								<textarea 
								class="form-control"
								placeholder="Текст"
								ref="saveInput"
								v-model="strNote">	
								</textarea>	
							</div>
							<div class="bottom_part mt-2 pb-1">
								<template v-if="fileUpload_model==''">
									<div class="upload-file"> 
										<ReFileUpload 
											v-model="fileUpload_model"
											type="file"
											:multiple="false"
											
											acceptMime="image/*,application/pdf,application/mspowerpoint,application/powerpoint,application/vnd.ms-powerpoint,application/x-mspowerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
											:bShowTrash="false"
											v-on:change="OnUploadFile"
										/>
									</div>
								</template>
								<template v-else>
									<h5 class="upload-file">
										<a :href="fileUpload_model.fullpath" target="_blank">Посмотреть документ</a>
										<button class="ml-2 btn btn-icon btn-simple btn-danger" @click="DoDel()">
											<i class="tim-icons icon-trash-simple"></i>
										</button>
									</h5>
								</template>
								
								<base-button v-if="strNote!='' || fileUpload_model!=''" type="success" simple icon @click="SendSMS()" class="mr-0"><i class="d-inline-block tim-icons icon-send"></i></base-button>
							</div>
						</form>
					</tab-pane> -->
				</tabs> 
			</div>
			
		</card>

		
		<div v-for="(anal,a_index) in masLenta.anal" :key="anal.id"  class="lenta-item" :class="[{'last':a_index==(masLenta.anal.length-1)}]"> 
			<!-- <pre>{{getNotes(anal.note_id)}}</pre> -->
			
			<ReClientNote v-if="anal.note_id !='' && anal.note_id != 0 && !$GVO.isEmpty(getNotes(anal.note_id))" :objNote="getNotes(anal.note_id)" @onUpdate="getLenta()"/>
			<ReClientCall v-else-if="anal.call_id !='' && anal.call_id != 0 && !$GVO.isEmpty(getCalls(anal.call_id))" :objCall="getCalls(anal.call_id)" :recipientPhone="client_phone" />

		</div>

		<div class="pagination" v-if="bShowPaginBtn"><base-button @click="pClick()" class="mx-auto" type="success" simple>Загрузить ещё</base-button></div>	

		<!-- <pre>masLenta.anal {{masLenta.anal}}</pre> -->
	</div>
</template>

<script>
import { TabPane, Tabs } from 'src/components';
import ReFileUpload from "src/our_components/ReFileUpload.vue";
import ReClientNote from "src/our_components/Lenta/ReClientNote.vue";
import ReClientCall from "src/our_components/Lenta/ReClientCall.vue";
import moment from 'moment';
import {eventEmitter} from "src/plugins/globalComponents.js";
import { Select, Option, } from 'element-ui';


export default {
	name: 'ReLeadLentaNest',
	components: {
		ReFileUpload,
		ReClientNote,
		TabPane,
		Tabs,
		ReClientCall,
		[Select.name]: Select,
		[Option.name]: Option,

	},
	props: {
		client_id: [String,Number],	
		client_phone: [String,Number],	
		lead_id: [String,Number],	
		objService: Object,
		type:{
			type: String,
			default: 'lead',
		},
	},
	data () {
		return {
			ver: 1,
			bIsLoading:false,
			masLenta:[],
			bIsPostForm: true,	
			strNote: '',			
			fileUpload_model: '',
			//bIsLoading: false,
			textexample: 'Проверка. Пример текста',
			p:1,
			bShowPaginBtn: false,
			masCallAgain: [],
			// messageTypes:[{id:1, name:'Заметка'}, {id:2, name:'Сообщение WhatsApp'}],
			messageSelectedVal: 1,
			smth:'',
			value: 'tb_1', 
		}
	},
	computed: {

	},
	methods: {
		pClick(){
			this.p++;
			this.getLenta(false,true);
		},
		getLenta(bEmited=false,bChangePage=false){
			if(!bChangePage) this.p = 1;
			this.bIsLoading = true;
	
			this.$GVO.ApiCall('LEAD.GET_LEAD_LENTA',{flt:{lead_id:this.lead_id,'p':this.p, order_field: 'id desc'}})
				.then((objApi) => { 
					this.bIsLoading = false;
					//console.log('getLenta',objApi);
					if(objApi.success === true){
						if(typeof objApi.data.anal != 'undefined' && objApi.data.anal.length < 10) this.bShowPaginBtn = false; else this.bShowPaginBtn = true;
						if(!bChangePage){
							this.masLenta = this.$GVO.unlinkObject(objApi.data);
							
						}else{
							this.masLenta.anal = this.masLenta.anal.concat(this.$GVO.unlinkObject(objApi.data).anal);
							this.masLenta.call = this.masLenta.call.concat(this.$GVO.unlinkObject(objApi.data).call);
							// this.masLenta.callSubscribe = this.masLenta.callSubscribe.concat(this.$GVO.unlinkObject(objApi.data).callSubscribe);
							this.masLenta.note = this.masLenta.note.concat(this.$GVO.unlinkObject(objApi.data).note);
							// this.masLenta.cc = this.masLenta.cc.concat(this.$GVO.unlinkObject(objApi.data).cc);

						}
						
						// this.masCallAgain = [];
						// if(typeof objApi.data.cc != 'undefined'){
						// 	for(let i=0; i < objApi.data.anal.length; i++){
						// 		for(let j=0; j < objApi.data.cc.length; j++){
								
						// 			if(objApi.data.anal[i].cc_id === objApi.data.cc[j].id){
						// 				this.masCallAgain.push({result_descr:objApi.data.cc[j].result_descr, id:objApi.data.cc[j].id, dt_remember:objApi.data.cc[j].dt_remember});
										
						// 			}
						// 		}
						// 	}
						// }else {this.masCallAgain = []; }
						
					}
				}).catch(errorObjApi => {console.error(errorObjApi); this.bIsLoading = false;});
		},
		// getTask(task_id){
		// 	if(typeof this.masLenta.tasks != 'undefined'){ 
		// 		if(typeof this.masLenta.tasks[task_id] != 'undefined'){
		// 			this.masLenta.tasks[task_id].id = task_id;
		// 			return this.masLenta.tasks[task_id];
		// 		}
		// 	}
			
		// 	return {};
		// },	
		// getCallAgainInfo(id){
		// 	//console.log('getCallAgainInfo',id);
		// 	if(typeof this.masCallAgain != 'undefined'){
		// 		for(let i=0; i < this.masCallAgain.length; i++){
		// 			if(id === this.masCallAgain[i].id){
		// 				return this.masCallAgain[i];
		// 			}
		// 		}
		// 	}
		// 	return {};
		// },
		getNotes(note_id){
			if(typeof this.masLenta.note  != 'undefined'){ //console.log(this.masLenta.note);
				if(typeof this.masLenta.note[note_id] != 'undefined'){ 					
					return this.masLenta.note[note_id];
				}
			}
			return {};
		},	
		getCalls(call_id){
			if(typeof this.masLenta.call != 'undefined'){ ///console.log('this is this.masLenta.call ' +  this.masLenta.call);
				if(typeof this.masLenta.call[call_id] != 'undefined'){ 
					return this.masLenta.call[call_id];
				}
			}
			return {};
		},	
		// getCallsSubscribe(CALL_SUBSCRIBE_ID){
		// 	// console.log('this CALL_SUBSCRIBE_ID ' +  CALL_SUBSCRIBE_ID);
		// 	if(typeof this.masLenta.callSubscribe != 'undefined'){ //console.log('this is this.masLenta.anal ' +  this.masLenta.anal[CALL_SUBSCRIBE_ID]);
		// 		if(typeof this.masLenta.callSubscribe[CALL_SUBSCRIBE_ID] != 'undefined'){ 
		// 			//console.log('this isthis.masLenta.anal[CALL_SUBSCRIBE_ID] ' +  this.masLenta.anal[CALL_SUBSCRIBE_ID]);
		// 			return this.masLenta.callSubscribe[CALL_SUBSCRIBE_ID];
		// 		}
		// 	}
		// 	return {};
		// },	
		SendNote() {
			let now = moment().format("YYYY-MM-DD HH:mm:ss");
			
			this.$GVO.ApiCall('NOTES.INS',{
				iData:{
					'obj_type_name': this.type,
					'obj_id':this.lead_id,
					'title':'Заметка',
					'descr':this.strNote,
					'UpdTime': now,
					'atach_arr': this.fileUpload_model,	
				}
			}).then((objApi) => {
				//console.log(objApi);
				if(objApi.success === true){
					if(objApi.data.length > 0) {
						this.masLenta = objApi.data;
					}
					this.getLenta();	
				} 	
				this.bIsPostForm = !this.bIsPostForm;
				this.fileUpload_model = '';
				this.strNote = ''; 
					
			}).catch(errorObjApi => console.error(errorObjApi));			
		},		
		SendSMS(){
			// console.log('мы нажали кнопку Отправить СМС');
		},
		showPostForm() {
			this.bIsPostForm = !this.bIsPostForm;
			this.$nextTick(() => {
				this.$refs.saveInput.focus();
			});

		},
		DoDel(){			
			this.fileUpload_model = '';
		},
		OnUploadFile(objData){
			//console.log('OnUploadFile', objData);			
			this.bUploading=true;
			let objSendApi = {obj:'FileUpload',flt:{type:'notes_file'}};			
			this.$GVO.UploadFile(objData.formId,'UniUpload',objSendApi)
				.then(objApi => {  
					//console.log(objApi);
					if(objApi.success){
						this.fileUpload_model = objApi.data;						
										
					}else{
						alert(objApi.msg);
					}
					this.bUploading=false;
				})
				.catch(errorObjApi => {console.error(errorObjApi); this.bUploading=false;});
		},
		cancelForm() {
			this.bIsPostForm = !this.bIsPostForm;
			this.fileUpload_model = '';
			this.strNote = '';
		},
		
	},
	mounted() {
		
	},
	created(){
		// eventEmitter.$on('reload_tasks', this.getLenta);
		eventEmitter.$on('reload_lenta', this.getLenta);
		this.getLenta();	
	},
	beforeDestroy() {
		// Отписываемся от события
		// eventEmitter.$off('reload_tasks', this.getLenta);
		eventEmitter.$off('reload_lenta', this.getLenta);
	},
}
</script>

<style scoped>
	.ReLeadLentaNest {position: relative;}
	.overdue-text {color: #1d253b!important;}
/*============================ SEND NOTES ========================================*/
	.postAddForm-hide {
		display: none;
	}
	.postAddForm-show {
		display: block;
		margin-top: 15px;
	}
	.postForm {
		/* border: 1px solid transparent; */
		border: 1px solid #01B0E0;
		border-radius: 0.2857rem;
		position: sticky!important;
		bottom: 0;	
		z-index: 2;	
		margin-top: 16px;
	}
	.ReLeadLentaNest >>> .postAddForm .nav-pills .nav-item .nav-link {padding: 0px 7px;}
	.postForClick {padding: 15px 0px 0px 0px; cursor: pointer; width: fit-content; display: flex; width: 100%;}
	.postForm >>> .card-body {padding: 0px 5px 15px 10px!important;}
	.cancel-note-btn {position: absolute;  top: 0; right: 0;}
	.clientPage .card-collapse .postForm {
		background: #27293d;
	}
	.white-content .card:not(.card-white) .postForm {
		background: #fff;
	}
	.postForm:hover, .focus-shadow  {
		box-shadow: 0px 0px 10px rgba(1, 176, 224, 0.3);
	}
	.postForm h5 {
		margin-bottom: 0px;
	}
	.form-container {display: flex; flex-direction: column; justify-content: space-between; padding: 0px 5px;}
	.postForm .bottom_part, .top_part  {display: flex; flex-wrap: wrap; justify-content: space-between;}
	.postForm .bottom_part button, .fileinput {margin: 10px 10px 0px 0px;}

	.postAddForm >>> .nav-pills .nav-item i {line-height: 30px;}
	.postAddForm >>> .nav-pills .nav-item .nav-link {padding: 7px 20px; min-width: 80px;}
	.postAddForm >>> .tab-space {padding: 20px 0 10px 0px;}
	.upload-file {display: flex; align-items: center;}
	.upload-file h5 {margin-bottom: 0px; margin-right: 10px;}

	/* .note-btn-group {position: relative;}
	.note-btn-row {position: absolute; top: 5px; right: 0;} */

	.lenta-item.last .card-cinc {margin-bottom: 15px;}
</style>
